import React from 'react';
import I18n from 'i18n-js';
import {
  CheckoutOrderSummaryOrderItemShippingTotalFields,
  core_apimessages_CheckoutOrder_ShippingTotalDiscount_Type as ShippingTotalDiscountType,
} from '../schemas/rql';
import gql from 'graphql-tag';
import { RCTooltip } from '@reverbdotcom/commons/src/rc/RCTooltip';
import { I18N as Translate } from '@reverbdotcom/commons/src/components/translate';

interface IProps {
  order: CheckoutOrderSummaryOrderItemShippingTotalFields.Orders;
}

export default function CheckoutOrderSummaryLineItemShippingTotal({ order }: IProps) {
  function discountedShippingPrice() {
    if (order.shippingTotal.discount.type === ShippingTotalDiscountType.COMBINED_CHILD) {
      return (
        <RCTooltip type="underline" text={I18n.t('discovery.checkout.combineAndSaveTooltipText')}>
          {order.shippingTotal.discount.label}
        </RCTooltip>
      );
    }
    return (
      <Translate
        text="discovery.checkout.orderSummary.shippingCost"
        args={{ amount: order.shippingTotal.amountOwed.display }} />
    );
  }

  if (order.shippingTotal.discounted) {
    return (
      <>
        <p data-order-shipping-original-price className="opacity-70 td-line-through mb-0">
          <Translate
            text="discovery.checkout.orderSummary.shippingCost"
            args={{ amount: order.shippingTotal.originalAmountOwed.display }} />
        </p>
        <p data-order-discounted-shipping-total className="color-green weight-bold mb-0">
          {discountedShippingPrice()}
        </p>
      </>
    );
  }

  return (
    <p className="opacity-70 mb-0">
      <Translate
        text="discovery.checkout.orderSummary.shippingCost"
        args={{ amount: order.shippingTotal.amountOwed.display }} />
    </p>
  );
}

export const CheckoutOrderSummaryOrderItemShippingTotalFragment = gql`
fragment CheckoutOrderSummaryOrderItemShippingTotalFields on Checkout {
  _id
  orders {
    shippingTotal {
      originalAmountOwed {
        display
      }
      amountOwed {
        display
      }
      discounted
      discount {
        type
        label
      }
    }
  }
}
`;
